import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import { NotificationContainer } from '@ctsu/react-ctsu-ui';
import App from './App';

const root = createRoot(document.getElementById('root'));
root.render(
  <>
    <NotificationContainer />
    <App />
  </>
);
